var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", {
    staticClass: "flipdown m-0 p-0",
    staticStyle: { display: "inline-block", transform: "scale(.7)" },
    attrs: { id: "flipdown" },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }